var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-list-group-item',{staticClass:"px-2 py-1",attrs:{"button":""}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"1"}}),_c('b-col',[_vm._v(" Nothing Found... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }